import { useI18nContext } from "@hopper-b2b/i18n";
import { CircularProgress } from "@material-ui/core";
import clsx from "clsx";
import type { WatchTripFormState } from "./WatchTripForm";

interface WatchTripFormFooterProps {
  cn: (elementName: string) => string;
  formState: WatchTripFormState;
  onCancel: () => void;
}

export const WatchTripFormFooter = ({
  cn,
  formState,
  onCancel,
}: WatchTripFormFooterProps): JSX.Element => {
  const { t } = useI18nContext();

  return (
    <div className={cn("button-group")}>
      <button
        className={clsx(cn("cancel-button"), "cancel-button")}
        type="button"
        onClick={onCancel}
        disabled={formState.isSubmitting}
      >
        {t("cancel")}
      </button>
      <button
        className={clsx(cn("cta-button"), "cta-button")}
        type="submit"
        form="watch-trip-form"
        disabled={formState.isSubmitting || !formState.isValid}
        aria-label={formState.isSubmitting ? t("loading") : undefined}
      >
        {formState.isSubmitting ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          t("priceWatch.titles.buttonCopy")
        )}
      </button>
    </div>
  );
};
